import type { Booking } from '../../Shared/Types/bookingTypes';

export interface ExpenseInvoiceBookingLookup {
  id: number;
  offerName: string | null;
  bookingDateFrom: string;
  bookingDateTo: string;
}

export const mapBookingToExpenseInvoiceLookup = (
  booking: Booking | undefined | null
): ExpenseInvoiceBookingLookup | undefined => {
  if (!booking) {
    return undefined;
  }

  return {
    id: booking.id,
    offerName: booking.offerName ?? null,
    bookingDateFrom: booking.bookingDateFrom,
    bookingDateTo: booking.bookingDateTo,
  };
};
